<template>
    <div>
        <crud-facecade
            :url="init.url"
            v-wechat-title="title"
            :tableHeight="tableHeight"
            :columns="init.columnList"
            :buttons="init.buttons"
            :addButton="{ permission: 'role:create' }"
            :deleteButton="{ permission: 'role:delete' }"
            :updateButton="{ permission: 'role:update' }"
            @AssignPermission="AssignPermission"
            @AssignWorkbar="AssignWorkbar"
        >
            <!--<el-row slot="header">
        <el-col :span="4">{{headerName}}</el-col>
      </el-row>-->
        </crud-facecade>

        <form-dialog
            ref="ruleForm3"
            :title="assignWorkbar.title"
            :data="assignWorkbar.data"
            :visible.sync="assignWorkbar.dialogFormVisible"
            :columns="assignWorkbar.columns"
            @confirm="SaveWorkbar"
        ></form-dialog>

        <tree-dialog
            :title="assignPermission.title"
            :strictly="false"
            :visible.sync="assignPermission.dialogFormVisible"
            :data="assignPermission.data"
            :default-checked-keys="assignPermission.defaultCheckedKeys"
            @confirm="SavePermission"
        >
            <template slot="row" slot-scope="{ node, data }">
                <span>{{ data.name }}</span>
                <span>
                    {{ data.path }}
                </span>
            </template>
        </tree-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `Role`,
    data() {
        return {
            title: `角色管理`,
            init: {
                url: `/api/AcisSystem/Role`,
                columnList: [
                    {
                        type: `string`,
                        prop: `id`,
                        label: `编号`,
                        width: `80`,
                        isListable: false,
                        isExpand: false,
                        isEditable: false,
                        isCreatable: false,
                        isKey: true
                    },
                    {
                        type: `number`,
                        prop: `print_order`,
                        label: `排序`,
                        width: `180`,
                        isListable: true,
                        isExpand: false,
                        isEditable: false,
                        isCreatable: false,
                        readonly: false,
                        sortable: true,
                        isDisplayOrder: true
                    },
                    {
                        type: `string`,
                        prop: `name`,
                        label: `名称`,
                        isListable: true,
                        isExpand: false,
                        isEditable: true,
                        isCreatable: true,
                        searchable: true,
                        isKey: false,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    },
                    {
                        type: `rbool`,
                        prop: `is_deleted`,
                        label: `状态`,
                        width: `70`,
                        isListable: true,
                        isExpand: false,
                        isEditable: true,
                        isCreatable: true,
                        searchable: true,
                        sortable: false,
                        readonly: false,
                        options: `is_enabled`,
                        default: true
                    }
                ],
                buttons: [
                    {
                        label: `分配权限`,
                        type: `primary`,
                        emit: `AssignPermission`,
                        permission: `default`
                    },
                    {
                        label: `分配工作栏`,
                        type: `primary`,
                        emit: `AssignWorkbar`,
                        permission: `default`
                    }
                ]
            },
            assignPermission: {
                title: `分配权限`,
                dialogFormVisible: false,
                data: [],
                roleId: ``,
                defaultCheckedKeys: []
            },
            assignWorkbar: {
                title: `分配工作栏`,
                dialogFormVisible: false,
                data: { roleId: 0, bars: [] },
                columns: [
                    {
                        type: `checkboxgroup`,
                        prop: `bars`,
                        label: `工作栏:`,
                        options: [],
                        colspan: 24
                    }
                ]
            }
        }
    },
    created() {
        //  this.$store.dispatch("getDepartments")
    },
    computed: {
        ...mapGetters([`menus`, `screenHeight`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 190) || 0
        }
    },
    methods: {
        switchToTree(root, allpermission) {
            return root.map(r => {
                let children = []
                children = _.filter(allpermission, { parent_id: r.id })

                return {
                    id: r.id,
                    name: r.description,
                    path: r.permission_type,
                    disabled: false,
                    nocheck: true,
                    children: children.length > 0 ? this.switchToTree(children, allpermission) : []
                }
            })
        },
        AssignPermission({ row, index }) {
            let that = this
            that.assignPermission.roleId = row.id
            let req1 = this.myaxios.get(`/api/AcisSystem/Permission/Get`) // 获取所有权限
            let req2 = this.myaxios.get(`/api/AcisSystem/Role/GetPermissions/${row.id}`) // 获取某角色的所有权限
            that.axios
                .all([req1, req2])
                .then(
                    that.axios.spread(function(allPerm, rolePerm) {
                        let root = _.filter(allPerm, p => p.parent_id == 0 || !p.parent_id)
                        that.assignPermission.dialogFormVisible = true
                        that.assignPermission.data = that.switchToTree(root, allPerm)
                        let roleids = rolePerm.map(role => role.id)
                        that.assignPermission.defaultCheckedKeys = roleids || []
                    })
                )
                .catch(function(error) {
                    //  网络等其他原因
                    console.log(error)
                })
        },
        AssignWorkbar({ row, index }) {
            let that = this
            let req2 = that.myaxios.get(`/api/AcisSystem/Role/GetWorkBars/${row.id}`)
            let req1 = that.myaxios.get(`/api/AcisSystem/WorkBar/Get`)
            that.axios.all([req1, req2]).then(
                that.axios.spread(function(allbars, roleBars) {
                    let workbars = _.filter(allbars, { is_deleted: false })
                    that.assignWorkbar.data.bars = roleBars.map(r => r.id) || [] // 选中的工作栏
                    let wbs = workbars.map(function(val, index, array) {
                        return { value: `` + val.id, label: val.name }
                    })
                    that.assignWorkbar.columns[0].options = wbs // 设置待选项
                    that.assignWorkbar.data.roleId = row.id
                    that.assignWorkbar.dialogFormVisible = true
                })
            )
        },
        SavePermission(e) {
            let that = this
            let checkedPerms =
                e.length > 0
                    ? e.map(v => {
                        return { permission_id: v.id, role_id: this.assignPermission.roleId }
                    })
                    : [{ role_id: this.assignPermission.roleId }]
            this.myaxios.post(`/api/AcisSystem/Role/AssignPermissions`, checkedPerms).then(
                data => {
                    that.assignPermission.dialogFormVisible = false
                    // console.log(data)
                },
                res => {
                    console.log(res)
                }
            )
        },
        SaveWorkbar(data) {
            let that = this
            let barList = []
            let selectBars = data.bars
            selectBars.forEach(function(barid) {
                if (barid) {
                    barList.push({ work_bar_id: barid, role_id: that.assignWorkbar.data.roleId })
                }
            })
            this.myaxios.post(`/api/AcisSystem/Role/AssignWorkBars`, barList).then(
                data => {
                    that.assignWorkbar.dialogFormVisible = false
                },
                res => {
                    console.log(res)
                }
            )
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Role/Index.vue